
/**
 * Checks for card payloads in HTML by card type.
 * @param {string} html
 * @param {string} cardType
 * @returns {{found: boolean, type: string|null}}
 */
export function checkCardPayload(html, cardType) {
    var found = false;
    var type = null;
    var adaptiveCardTagRegex = /<script\s+?type=\"application\/adaptivecard\S+?json\".*?>([^]*?)<\/script>/mi;
    var messageCardTagRegex = /<script\s+?type=\"application\/ld\S+?json\".*?>([^]*?)<\/script>/mi;
    var adaptiveCardTypeRegex = /\"type"\:\s*\"(\w+?)\"/mi;
    var messageCardTypeRegex = /\".?type"\:\s*\"(\w+?)\"/mi;
    var cardTagRegex = adaptiveCardTagRegex;
    var typeRegex = adaptiveCardTypeRegex;
    if (cardType.toLowerCase() === "messagecard") {
        cardTagRegex = messageCardTagRegex;
        typeRegex = messageCardTypeRegex;
    }
    var match = html.match(cardTagRegex);
    if (match) {
        var scriptText = match[1];
        match = scriptText.match(typeRegex);
        if (match) {
            type = match[1];
        }
        if (cardType === "messagecard") {
            if (type) {
                var typeLower = type.toLowerCase();
                found = typeLower === "messagecard" || typeLower === "adaptivecard" || typeLower === "signedmessagecard" || typeLower === "signedadaptivecard";
            }
        } else {
            found = true;
        }
    }
    var signedCardMicrodataRegex = /<\w+\s+?itemprop=\"@type\".*?content=\"(\w+?)\".*?>/mi;
    match = html.match(signedCardMicrodataRegex);
    if (match && match[1].toLowerCase().indexOf(cardType) !== -1) {
        found = true;
        type = match[1] + "_MicroData";
    }
    var result = { found: found, type: type };
    return result;
}